export default {
  submit: '提交',
  numberOfAtt: '人数',
  email: '邮箱',
  phone: '电话',
  name: '姓名',
  company: '公司名称',
  welcome: '欢迎光临楚天展台！请填写信息，我们将为您发送感兴趣的产品资料，谢谢！',
  signIn: '活动签到',
  ctkj: '楚天科技',
  zhCN: '中文',
  enUs: 'English',
  esEs: 'Español',
  deDe: 'Deutsch',
  ruRu: 'Русский язык',
  new_dept: '部门/岗位',
  new_title: '职位',
  new_nation: '国家',
  new_product: '产品类型',
  requiredMsg: '请填写必填字段',
  successMsg: '提交成功',
  jobNumber: '工号',
  jobNumberPlaceholder: '请输入工号',
  passwordReset: '密码重置',
  jobNumberRule1: '请填写工号',
  jobNumberRule2: '请输入正确的工号',
  verificationCode: '钉钉验证码',
  verificationCodePlaceholder: '请输入钉钉验证码',
  sendCode: '发送验证码',
  codeNotice: '验证码将发送到钉钉工作通知,有效时间2分钟',
  newPwd: '新密码',
  newPwdRule1: '请输入新密码',
  newPwdRule2: '密码需要包含字母、数字、符号（.!@#），且长度不能低于10位',
  confirmPwd: '确认新密码',
  confirmPwdRule1: '确认新密码',
  confirmPwdRule2: '两次输入密码不一致',
  backHome: '返回首页',
  changePwd: '修改密码',
  editSucess: '修改成功',
  editPwdError1: '重置密码失败，密码要求10位以上，字母+数字+特殊字符（.!@#）',
  sendSucess: '发送成功',
  sendAagain: '重新发送',
  new_tkproduct: '感兴趣的产品或解决方案',
  jbxx: '基本信息',
  sbzl: '设备资料',
  gzt: '工作台',
  sbxlh: '设备序列号',
  zjbm: '主机编码',
  sbmc: '设备名称',
  ggxh: '规格型号',
  bxjzrq: '保修截止日期',
  zbq: '质保期（天）',
  zwwj: '暂无文件',
  sbbx: '设备报修',
  back: '返回',
  add: '新增',
  nomore: '没有更多数据了',
  nodata: '暂无数据',
  tc: '停产',
  scz: '生产中',
  wtms: '问题描述',
  lxfs: '联系方式',
  ckcljd: '查看处理进度',
  sqcljd: '收起处理进度',
  ts: '提示',
  qrsfsc: '确认删除这条数据吗？',
  qtxxm: '请输入姓名',
  qsrsbycxx: '请输入设备异常现象、报错信息、操作步骤等',
  sbsyzt: '设备使用状态',
  qtxdhhyx: '请填写电话或邮箱',
  attach: '附件',
  qsczp: '请上传照片',
  ygb: '已过保',
  gbt: '天',
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-CN.js